import "./Contacts.css";

import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";

import { API } from "aws-amplify";
import { CSVLink } from "react-csv";
import IosRefresh from "react-ionicons/lib/IosRefresh";
import LoaderButton from "../components/LoaderButton";
import axios from "axios";

export default function Contacts(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [account, setAccount] = useState(null);
  const [navLink, setNavLink] = useState("");
  const [csvName, setCsvName] = useState("");
  const [csvData, setCsvData] = useState(null);

  useEffect(() => {
    async function onLoad() {
      try {
        const accounts = await loadAccounts();
        const account = accounts.filter(
          (account) => account.accountId === props.accountId
        )[0];
        setAccount(account);
      } catch (e) {
        alert(e);
      }

      setIsLoading(false);
    }

    onLoad();
  }, [props.isAuthenticated, props.accountId]);

  function loadAccounts() {
    return API.get("accounts", "/accounts");
  }

  function validateForm() {
    return navLink.includes("linkedin.com/sales/lists/people/");
  }

  async function generateCSV() {
    setIsDownloadLoading(true);
    try {
      const { data } = await axios.post(
        "https://legacy.api.conversify.ai/exportSalesNavList",
        null,
        {
          params: {
            accountId: account.accountId,
            userId: account.userId,
            listUrl: navLink,
          },
        }
      );

      const { name, csv } = data;
      setCsvName(name);
      setCsvData(csv);
      setIsDownloadLoading(false);
    } catch (e) {
      setIsError(true);
      setIsDownloadLoading(false);
      console.log(e);
    }
  }

  function renderContactsDownload() {
    return (
      <div className="Contacts">
        {isError ? (
          <div>
            <Row>
              <Col sm={12} className="text-center">
                <p style={{ opacity: 1, textAlign: "center" }}>
                  <b>
                    {" "}
                    <span role="img" aria-label="sad">
                      😞
                    </span>{" "}
                    Hmm ...{" "}
                  </b>
                </p>
                <p>There was an issue creating your list of contacts.</p>
              </Col>
            </Row>
          </div>
        ) : !isDownloadLoading ? (
          csvData ? (
            <Row>
              <Col sm={12}>
                <CSVLink
                  data={csvData}
                  filename={`${csvName}.csv`}
                  target="_blank"
                  className="btn-secondary"
                >
                  Download your CSV
                </CSVLink>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm={12}>
                <FormGroup controlId="dailyLimit">
                  <ControlLabel>
                    {account.firstName}'s Sales Nav List URL{" "}
                    <small>(export up to 1000 contacts at a time)</small>
                  </ControlLabel>
                  <FormControl
                    value={navLink}
                    type="text"
                    placeholder="https://www.linkedin.com/sales/lists/people/6664942858790850560?sortCriteria=CREATED_TIME"
                    onChange={(e) => setNavLink(e.target.value)}
                  />
                </FormGroup>
                <LoaderButton
                  type="submit"
                  className="other-btn pull-right"
                  isLoading={isLoading}
                  disabled={!validateForm()}
                  onClick={() => generateCSV()}
                >
                  Download
                </LoaderButton>
              </Col>
            </Row>
          )
        ) : (
          <Row>
            <Col sm={12}>
              <p style={{ opacity: 1, textAlign: "center" }}>
                <b>Exporting your contacts ...</b>
              </p>
              <p style={{ opacity: 1, textAlign: "center" }}>
                Don't touch anything - this will take about a minute.
              </p>
              <img
                style={{ width: "100%" }}
                alt="loading-gif"
                src="https://conversify-marketing.s3.amazonaws.com/creating-account_instantpipeline.gif"
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }

  return (
    <div className="">
      {isLoading ? (
        <div className="text-center">
          <br />
          <IosRefresh fontSize="60px" color="#3EA9F5" rotate={true} />
        </div>
      ) : (
        renderContactsDownload()
      )}
    </div>
  );
}
